import { CustomData } from '../datapoints/AriaDatapoint';
import { PerformanceDatapoint } from '../datapoints/PerformanceDatapoint';

export function logQoSSuccess(
    scenarioName: string,
    duration?: number,
    customData?: CustomData
): void {
    const performanceDatapoint = new PerformanceDatapoint(scenarioName, { isQos: true });
    if (customData) {
        performanceDatapoint.addCustomData(customData);
    }
    performanceDatapoint.end(duration);
}
